import React, { Component } from "react";
import PropTypes from "prop-types";
import { Deedle } from "components";
import moment from "moment-timezone";
import { AmericanDateFormat } from "utils/formatters";

class WageDeductionAuthorization extends Component {
  static propTypes = {
    wageDeductionAuthorization: PropTypes.shape({
      stewardAuthorizedAt: PropTypes.string,
      debtorAuthorizedAt: PropTypes.string,
      stewardType: PropTypes.string,
    }),
  };

  authorizedAt = timeString => {
    return timeString
      ? moment(timeString)
          .tz("America/New_York")
          .format(AmericanDateFormat)
      : "Not signed";
  };

  render() {
    const { wageDeductionAuthorization } = this.props;
    const stewardHasSigned = wageDeductionAuthorization.stewardAuthorizedAt;
    const clientHasSigned = wageDeductionAuthorization.debtorAuthorizedAt;
    const signedBySomeone = stewardHasSigned || clientHasSigned;

    return (
      <section>
        <h2>Wage Deduction Authorization</h2>
        {!signedBySomeone && <p>Not Available</p>}

        {stewardHasSigned && (
          <Deedle
            term={`${wageDeductionAuthorization.stewardType} Signed At`}
            definition={this.authorizedAt(
              wageDeductionAuthorization.stewardAuthorizedAt,
            )}
          />
        )}

        {clientHasSigned && (
          <Deedle
            term="Client Signed At"
            definition={this.authorizedAt(
              wageDeductionAuthorization.debtorAuthorizedAt,
            )}
          />
        )}
      </section>
    );
  }
}

export default WageDeductionAuthorization;
